export const YEZIN = '예진';
export const START = '설문 시작하기';
export const B2C_START = '시작하기';

export const CLOSE = '닫기';

export const CONFIRM = '확인';

export const SURVEY_FOR_BODY_PART_INFO = '불편하신 부위를 모두 선택하세요.';
export const SURVEY_FOR_SYMPTOM_INFO = '불편하신 전신 증상을 모두 선택하세요.';
export const SURVEY_CHECK_INFO = '해당 되는 부위는 모두 체크 하세요';
export const SURVEY_DETAIL_INFO_HEADER = '해당되는 증상을 모두 고르세요.';
export const SURVEY_DETAIL_INFO_FOOTER = '현재 앓고 있는 질환을 고르세요.';

// 간지
export const PREV_BUTTON = '이전으로';
export const NEXT_BUTTON = '다음으로';
export const NEXT_TO_CONFIRM_BUTTON = '결과보기';

// Term
export const SURVET_START_COMMENT = '반갑습니다.';
export const TERM_GUIDE_COMMENT = `보다 정확한 진료를 위해 고객님께서 가지고 계신 불편한 증상들을 상세히 여쭙고자 합니다.
그럼 시작하겠습니다.`;
export const SERVICE_TERM_AGREEMENT_COMMENT = '(필수)서비스 이용약관 동의';
export const PERSONAL_TERM_AGREEMENT_COMMENT = '(필수)개인정보 처리방침 동의';

// MainCategory
export const MAIN_CATEGORY_TITLE = '주증상';
export const MAIN_CATEGORY_GUIDE = '가장 불편하신 증상을 1개 골라주세요.';
export const NO_ANSWER = '선택지에 없음';

// ModeSelect
export const MODE_SELECT_BUTTON = '다음단계';
export const MODE_SELECT_TITLE = '첩약(한약)건강보험 혜택 확대';
export const MODE_SELECT_GUIDE = `아래 질환 중 하나에 해당되시면, 건강보험,
실비보험을 적용받아 첩약(한약)을
복용하실 수 있습니다. (본인부담률 30~40%)`;

// MainSymptom
export const MAIN_SYMPTOM_TITLE = '주증상';
export const MAIN_SYMPTOM_GUIDE_1 = '불편하신 증상에 대해 상세히 적어주세요.';
export const MAIN_SYMPTOM_GUIDE_2 = '(저희 의료기관을 방문해주신 이유는 무엇인가요?)';
export const MAIN_SYMPTOM_BUTTON = '입력 후 설문시작';
export const MAIN_SYMPTOM_PLACEHOLDER = '현재 가장 불편하신 증상을 입력해주세요.';

// DetailSurvey
export const DETAIL_SURVEY_GUIDE_1 = '증상의 불편하신 정도와';
export const DETAIL_SURVEY_GUIDE_2 = '증상이 발현된 시점을 알려주세요.';
export const TEXT_AREA_PLACEHOLDER = '여기에 입력해주세요.';
export const ONSET_OPTIONS = ['일주일 이내', '1개월 이내', '3개월 이내', '6개월 이내', '6개월 이상'];
export const SCALE_DESC = '증상의 불편하신 정도를 알려주세요.';
export const ONSET_DESC = '증상이 발현된 시점을 알려주세요.';

// OptionalSurveys
export const OPTIONAL_SURVEYS_TITLE = '증상선택';
export const OPTIONAL_SURVEYS_GUIDE = '불편하신 전신 증상을 모두 선택하세요.';

// Continue
export const CONTINUE_COMMENT = '잠시만요!';
export const CONTINUE_GUIDE_1 = `입력 중인 설문이 있습니다.`;
export const CONTINUE_GUIDE_2 = `이어서 진행하시겠습니까?`;
export const CONTINUE_GUIDE_3 = `처음부터 하기를 누르면 답변이 초기화됩니다.`;
export const CONTINUE_SURVEY_BUTTON = '이어서 답변하기';
export const INIT_SURVEY_BUTTON = '처음부터';

// CheerUp
export const CHEER_UP_TITLE = '감사합니다!';
export const CHEER_UP_GUIDE_1 = '다음은 정확한 진료를 위한 필수 질문입니다.';
export const CHEER_UP_GUIDE_2 = '주증상의 원인이 될 수도 있으니';
export const CHEER_UP_GUIDE_3 = '꼼꼼히 답변해주세요.';

// Confirm
export const CONFIRM_TITLE = '수고하셨습니다!';
export const CONFIRM_COMMENT_1 = '설문이 모두 완료되었습니다.';
export const CONFIRM_COMMENT_2 = '답변하신 내용 외에 불편한 증상 있으신가요?';
export const CONFIRM_PLACE_HOLDER = '불편하신 증상을 입력해주세요.';
export const NOT_ANYMORE_ANSWER = '없습니다, 모든 증상을 말 한 것 같습니다.';
export const ADDITIONAL_SYMPTOM_ANSWER = '추가로 이야기하고 싶은 증상이 있습니다.';

// Review
export const REVIEW_TITLE = '설문평가';
export const REVIEW_COMMENT = '본 설문이 증상을 설명하는 데 도움이 되셨나요?';
export const REVIEW_PLACE_HOLDER = '개선사항이 있다면 자유롭게 입력해주세요. :)';
export const REVIEW_NEXT_BUTTON = '제출하기';

// Ending
export const ENDING_TITLE = '제출완료';
export const ENDING_COMMENT = `입력한 증상이 한의원에 제출되었습니다.
한의사 선생님께 상담받으세요. 😊`;

// TreatmentIsProgressing
export const TREATMENT_IS_PROGRESSING_TITLE = '진료 중인 환자입니다.';
export const TREATMENT_IS_PROGRESSING_COMMENT = `한의원에 문의하여 진료 완료 후,
설문을 다시 시도해 주세요.`;

// NotFoundError
export const NOT_FOUND_ERROR_TITLE = 'Not Found';
export const NOT_FOUND_ERROR_COMMENT = '페이지를 찾을 수 없습니다.';

// Expired
export const EXPIRED_TITLE = '페이지 만료';
export const EXPIRED_COMMENT = '입력기한 초과로 페이지가 만료되었습니다.';

// Expired
export const COMPLETED_TITLE = '응답완료';
export const COMPLETED_COMMENT = '이미 설문을 완료하였습니다.';
